import { format } from 'date-fns';
import { CalendarIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useEffect, useState } from 'react';

interface DatePickerProps {
  date?: Date;
  setDate: (date: Date | null) => void;
  className?: string;
}

export function DatePicker({ date, setDate, className }: DatePickerProps) {
  const [open, setOpen] = useState(false);
  const [month, setMonth] = useState(date ?? new Date());

  useEffect(() => {
    if (open) {
      setMonth(date ?? new Date());
    }
  }, [open, date]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className={cn('w-[225px] justify-start text-left font-normal bg-input mt-0.5', !date && 'text-muted-foreground', className)}>
          <CalendarIcon className="mr-2" />
          {date ? format(date, 'PPP') : <span>Select date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[9999]">
        <Calendar
          mode="single"
          selected={date}
          month={month}
          onMonthChange={setMonth}
          onSelect={(selected) => {
            if (!selected) {
              return;
            }
            setDate(selected);
            setOpen(false);
          }}
          captionLayout="dropdown"
          className='w-70 z-[9999]'
        />
      </PopoverContent>
    </Popover>
  );
}
